<div class="container course-detail">
    <div class="box-default3 w-100 shadow-lg">
      <h4>Skill Enhancement Courses</h4>
        <img src="assets/img/course/sec1.png" alt="SEC Image" class="img-fluid">
    </div>
</div>